import { Box } from "@mui/material";
import { useMyLeaveLeaveCards as useMyLeaveLeaveCardsDI } from "./use-leave-cards";
import { MyLeaveLeaveCard } from "my-leave/components";

export type LeaveTypesInJDolber =
  | "S" // Base
  | "T" // Study
  | "Q" // Covid
  | "D" // Eszjtv
  | "V"; // Emergency

export interface MyLeaveLeaveCardsProps {
  selectedYear: number;
  contractCode: string;
  showFilter?: LeaveTypesInJDolber[]; // If we only want to show just a specific type(s) of leaves, it's possible.
  padding?: string;
  useMyLeaveLeaveCards?: typeof useMyLeaveLeaveCardsDI;
}

export const MyLeaveLeaveCards: React.FC<MyLeaveLeaveCardsProps> = ({
  contractCode,
  padding = "16px 0px",
  useMyLeaveLeaveCards = useMyLeaveLeaveCardsDI,
  ...props
}) => {
  const { data, neededCards } = useMyLeaveLeaveCards({
    contractCode,
    ...props,
  });

  return (
    <Box>
      {neededCards.map((type) => (
        <Box
          padding={padding}
          key={`${contractCode}-${type}`}
          data-testid={`my-leave-leave-card-container-${type}`}
        >
          <MyLeaveLeaveCard
            type={type}
            fulfilled={data.fulfilled[type]}
            requested={data.requested[type]}
            requestable={data.available[type]}
          />
        </Box>
      ))}
    </Box>
  );
};
